<template>
  <el-card
    style="height:170px;display: flex !important;"
    :shadow="disabled?'never':'hover'"
    class="mt-10"
    v-bind:class="{ 'o-070':disabled, 'hand':!disabled }"
    @click.native="goto(section)"
    :disabled="disabled">
    <div style="display:flex">
      <div>
        <i :class="tileClass" v-if="icon" style="float:left;height:100%"></i>
        <el-image
          v-if="imageUri"
          :style=imageStyle
          :src="imageUri"
          class="mr-10"></el-image>
      </div>
      <div class="mt-10">
        <span class="">{{title}}</span><br>
      </div>
    </div>
    <div class="mt-5">
      <span class="fs-14 secondary-text">{{description}}</span>
    </div>
  </el-card>
</template>
<script>
//import Section


export default {
  name : "reportTile",
  props: {
    section : {type : String},
    disabled : {type : Boolean, default : false},
    title : {type : String},
    description : {type : String},
    icon : {type : String},
    imageUri: {type: String},
    imageStyle: {
      type: String,
      default: "width: 80px;float:left",
    }
	},
  data() {
    return {

    };
  },
  components : {

  },
  computed : {
    tileClass () {
      return `${this.icon} fs-50 mr-10 o-070`
    },
  },
  methods : {
    goto(section){
      if(!this.disabled){
        var index = '/settings/' + section
  			this.$router.push(index)
  			this.$emit('push-page', {page:index})
      }else{
        this.$message.warning("Ce section est en cours de développement.");
      }

    }
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>

.hand {
  cursor:pointer;
}

</style>
